<template>
  <div id="wide-card" :class="[this.$store.state.tab === 3 ? 'wide-card-container-investor' : '' , 'wide-card-container']">
    <img class="wide-card-img" :src="thinnerCards.includes(cardType) ? investorCard : wideCard"/>
    <wide-card-inner :cardType="cardType" :info="item"></wide-card-inner>
      <div v-if="!thinnerCards.includes(cardType)" :class="[this.$lang === 'ar' ? 'wide-black-blur-left' : 'wide-black-blur-right' ,'wide-black-blur']"></div>
      <router-link :to="`/news-details/${item.type}/${item.id}`">
        <a>
          <div v-if="!thinnerCards.includes(cardType)" :class="[this.$lang === 'ar' ? 'wide-yellow-btn-left' : 'wide-yellow-btn-right' ,'wide-yellow-btn flex-center']">
            <div class="white-blur"></div>
            <img class="arrow-img" src="../../assets/icons/black-arrow.svg">
          </div>
        </a>
      </router-link>
      <div  v-if="!thinnerCards.includes(cardType)" :class="[this.$lang === 'ar' ? 'wide-blur-outer-button-left' : 'wide-blur-outer-button-right', 'wide-blur-outer-button']">
      </div>
    </div>
</template>
<script>
import WideCardInner from './WideCardInner'
import wideCard from '../../assets/images/midShadow-wide-card.svg'
import investorCard from '../../assets/images/mid-shadow-investor-card.svg'
import $ from 'jquery'
export default {
  components: { WideCardInner },
  props: { data: Object, cardType: String, sliderHolder: String },
  data () {
    return {
      wideCard: wideCard,
      investorCard: investorCard,
      thinnerCards: ['investor-relations'],
      item: {}
    }
  },
  created () {
    this.item = this.data
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('#wide-card .arrow-img').css({ transform: 'rotate(270deg)' }) : $('.arrow-img').css({ transform: 'rotate(0deg)' })
    })
  },
  methods: {
  }
}
</script>
<style>
#wide-card{
  margin: 0 auto;
  pointer-events: none;
}
.wide-card-container{
  width: 450px;
  position: relative;
}
.wide-card-container-investor {
  width: 440px;
}
.wide-card-img{
  width: 100%;
  border-radius: 8px;
  user-select: none;
}
.wide-inner-card-btn{
  position: absolute;
  bottom: 68px;
  z-index: 1;
  width: 100px;
  height: 100px;
}
.wide-inner-card-btn-img{
  width: 100%;
  height: 100%;
}
.wide-black-blur{
  position: absolute;
  bottom: 50px;
  width: 42px;
  height: 42px;
  background: rgba(106, 106, 106, 0.6);
  filter: blur(10px);
  z-index: 99;
}
.wide-blur-outer-button{
  pointer-events: all!important;
  cursor: pointer;
  width: 83px;
  height: 83px;
  bottom: 36px;
  position: absolute;
  border-radius: 100px;
  transition: all .3s ease-in-out;
  border: 1.5px solid rgba(255, 255, 255, 0.7);
  z-index: 100;
  filter: blur(1px);
}
.wide-yellow-btn{
  pointer-events: all!important;
  cursor: pointer;
  width: 80px;
  height: 80px;
  background: #FFCB05;
  bottom: 38px;
  position: absolute;
  border-radius: 100px;
  transition: all .3s ease-in-out;
  z-index: 101;
}
.wide-yellow-btn:hover{
  transform: scale(1.15);
}
.wide-blur-outer-button-left{
  left: 80px;
}
.wide-blur-outer-button-right {
  right: 80px;
}
.wide-yellow-btn-left{
  left: 81px;
}
.wide-yellow-btn-right{
  right: 81px
}
.wide-black-blur-left{
  left: 87px;
}
.wide-black-blur-right{
  right: 87px
}
.black-arrow-container{
  position: absolute;
  top: calc(50% - 11.46px);
  left: calc(50% - 11.46px)
}
.white-blur {
  position: absolute;
  top: -13px;
  left: -4px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  filter: blur(15px);
  border-radius: 100px;
}
.arrow-img{
  width: 18px;
}
@media (max-width: 550px) {
  .arrow-img{
    height: 15px;
  }
  .wide-card-container{
    width: 385px;
    margin: 0 auto;
  }
  .wide-inner-card-btn{
    width: 65px;
    height: 65px;
  }
  .wide-inner-card-btn {
    position: absolute;
    bottom: 44px;
  }
  .black-arrow-container img{
    width: 15px;
  }
  .black-arrow-container{
    position: absolute;
    top: calc(50% - 10px);
    left: calc(50% - 8.445px);
  }
  .wide-yellow-btn{
    width: 68px;
    height: 68px;
    bottom: 31px;
  }
  .wide-blur-outer-button {
    width: 71px;
    height: 71px;
    bottom: 30.5px;
  }
  .wide-yellow-btn-left{
    left: 69.5px;
  }
  .wide-yellow-btn-right{
    right: 70.5px
  }
  .wide-blur-outer-button-left{
    left: 68px;
  }
  .wide-blur-outer-button-right {
    right: 69px;
  }
  .wide-black-blur-left{
    left: 70px;
  }
  .wide-black-blur-right{
    right: 69px
  }
  .wide-black-blur {
    bottom: 32px;
  }
}
@media (max-width: 400px) {
  .arrow-img{
    height: 15px;
  }
  .wide-card-container{
    width: 340px;
    margin: 0 auto;
  }
  .wide-inner-card-btn{
    width: 55px;
    height: 55px;
  }
  .wide-inner-card-btn {
    position: absolute;
    bottom: 44px;
  }
  .black-arrow-container img{
    width: 14px;
  }
  .black-arrow-container{
    position: absolute;
    top: calc(50% - 10px);
    left: calc(50% - 8.445px);
  }
  .wide-yellow-btn{
    width: 60px;
    height: 60px;
    bottom: 29px;
  }
  .wide-blur-outer-button {
    width: 63px;
    height: 63px;
    bottom: 27px;
  }
  .wide-yellow-btn-left{
    left: 60.5px;
  }
  .wide-yellow-btn-right{
    right: 61px
  }
  .wide-blur-outer-button-left{
    left: 59px;
  }
  .wide-blur-outer-button-right {
    right: 59.5px;
  }
  .wide-black-blur-left{
    left: 58px;
  }
  .wide-black-blur-right{
    right: 56px
  }
  .wide-black-blur {
    bottom: 28px;
  }
}
</style>
